import { PagedRequest } from './types/requests'
import { PagedResponse } from './types/responses'

export default function <T>(
  req: PagedRequest,
  res: { count: number; results: any[] },
): PagedResponse<T> {
  return {
    ...res,
    currentPage: req.page || 1,
    totalPages: Math.ceil(res.count / (req.page_size || 10)),
  }
}
